var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('headerNav',{attrs:{"title":"详情"}}),(_vm.vinfo)?_c('div',{staticClass:"vmain"},[_c('div',{staticClass:"ftit"},[_vm._v(" "+_vm._s(_vm.vinfo.title)+" ")]),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.vinfo.content)}})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }